import { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

const CreateBlog = ({ editingPost = null, onDone }) => {
  const [title, setTitle] = useState("");
  const [subtitle, setSubtitle] = useState("");
  const [authorImage, setAuthorImage] = useState("");
  const [author, setAuthor] = useState("");
  const [content, setContent] = useState("");
  const [image, setImage] = useState(null);
  const [previewUrl, setPreviewUrl] = useState("");
  const [authorPreviewUrl, setAuthorPreviewUrl] = useState("");

  const [message, setMessage] = useState("");
  const [date, setDate] = useState("");

  // New state for resources
  const [resources, setResources] = useState([]);
  const [selectedResource, setSelectedResource] = useState("");

  // Prefill when editing
  useEffect(() => {
    if (editingPost) {
      setTitle(editingPost.title);
      setSubtitle(editingPost.subtitle);
      setAuthor(editingPost.authorName)
      setContent(editingPost.description);
      setAuthorImage(editingPost.authorImage);
      setAuthorPreviewUrl(editingPost.authorImage);
      setPreviewUrl(editingPost.thumbnailUrl || "");
      setSelectedResource(editingPost.resourceId || "");
      setDate(editingPost.date ? editingPost.date.slice(0, 10) : ""); // assuming date is ISO string
    }
  }, [editingPost]);

  // Fetch resource list (you can change this URL or use static list)
  useEffect(() => {
    const fetchResources = async () => {
      try {
        const res = await fetch(
          "https://tnbx7rvcbc.us-east-1.awsapprunner.com/resources"
        );
        const data = await res.json();
        setResources(data);
      } catch (err) {
        console.error("Failed to fetch resources", err);
      }
    };

    fetchResources();
  }, []);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImage(file);
    if (file) {
      const url = URL.createObjectURL(file);
      setPreviewUrl(url);
    }
  };
  const handleAuthorImageChange = (e) => {
    const file = e.target.files[0];
    setAuthorImage(file);
    if (file) {
      const url = URL.createObjectURL(file);
      setAuthorPreviewUrl(url);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("title", title);
    formData.append("subtitle", subtitle);
    formData.append("authorName", author);
    formData.append("description", content);
    if (image) formData.append("thumbnailUrl", image);
    if (authorImage) formData.append("authorImage", authorImage);

    formData.append("articleCategory", selectedResource); // Add selected resource
    formData.append("date", date); // Add selected resource

    try {
      const res = await fetch(
        editingPost
          ? `https://tnbx7rvcbc.us-east-1.awsapprunner.com/posts/${editingPost._id}`
          : "https://tnbx7rvcbc.us-east-1.awsapprunner.com/posts/createpost",
        {
          method: editingPost ? "PATCH" : "POST",
          body: formData,
        }
      );

      const data = await res.json();

      if (res.ok) {
        setMessage(editingPost ? "Blog updated!" : "Blog posted!");
        if (!editingPost) {
          setTitle("");
          setSubtitle("");
          setContent("");
          setImage(null);
          setPreviewUrl("");
          setSelectedResource("");
        }
        if (onDone) onDone();
      } else {
        setMessage(data.message || "Failed to submit blog.");
      }
    } catch (err) {
      console.error(err);
      setMessage("An error occurred.");
    }
  };

  const fetchPosts = () => {
    fetch("https://tnbx7rvcbc.us-east-1.awsapprunner.com/articles/categories")
      .then((response) => response.json())
      .then((data) => {
        setResources(data.data);
        console.log(data, "resosurs data");
      })
      .catch((error) => {
        console.error("Error fetching users:", error);
      });
  };

  useEffect(() => {
    fetchPosts();
  }, []);

  const modules = {
    toolbar: [
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ font: [] }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike"],
      [{ color: [] }, { background: [] }],
      [{ script: "sub" }, { script: "super" }],
      ["blockquote", "code-block"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ align: [] }],
      ["link", "image", "video"],
      ["clean"],
    ],
  };

  return (
    <div className="blog_dash_wrapper">
      <h2>{editingPost ? "Edit Blog" : "Create Blog"}</h2>
      <form onSubmit={handleSubmit}>
        <div className="blog_input">
          <label>Title</label>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
          />
        </div>
        <div className="blog_input">
          <label>Subtitle</label>
          <input
            type="text"
            value={subtitle}
            onChange={(e) => setSubtitle(e.target.value)}
          // required
          />
        </div>

        <div className="blog_input">
          <label>Upload Image</label>
          <input type="file" accept="image/*" onChange={handleImageChange} />
          {previewUrl && (
            <div style={{ marginTop: "10px" }}>
              <strong>Image Preview:</strong>
              <div>
                <img
                  src={previewUrl}
                  alt="Preview"
                  style={{
                    width: "200px",
                    marginTop: "5px",
                    borderRadius: "8px",
                  }}
                />
              </div>
              <button
                type="button"
                onClick={() => {
                  setImage(null);
                  setPreviewUrl("");
                }}
                style={{ marginTop: "5px" }}
              >
                Remove Image
              </button>
            </div>
          )}
        </div>

        <div className="blog_input">
          <label>Content</label>
          <ReactQuill value={content} onChange={setContent} modules={modules} />
        </div>

        <div className="blog_input">
          <label>Resource</label>
          <select
            value={selectedResource}
            onChange={(e) => setSelectedResource(e.target.value)}
            required
          >
            <option value="">Select a resource</option>
            {resources.map((res) => (
              <option key={res._id} value={res.name}>
                {res.name}
              </option>
            ))}
          </select>
        </div>
        <div className="blog_input">
          <label>Publish date</label>
          <input
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            required
          />
        </div>
        <div className="blog_input">
          <label>Author Name</label>
          <input
            type="text"
            value={author}
            onChange={(e) => setAuthor(e.target.value)}
          // required
          />
        </div>
        <div className="blog_input">
          <label>Author Image</label>
          <input type="file" accept="image/*" onChange={handleAuthorImageChange} />
          {authorPreviewUrl && (
            <div style={{ marginTop: "10px" }}>
              <strong>Image Preview:</strong>
              <div>
                <img
                  src={authorPreviewUrl}
                  alt="Preview"
                  style={{
                    width: "200px",
                    marginTop: "5px",
                    borderRadius: "8px",
                  }}
                />
              </div>
              <button
                type="button"
                onClick={() => {
                  setAuthorImage(null);
                  setAuthorPreviewUrl("");
                }}
                style={{ marginTop: "5px" }}
              >
                Remove Image
              </button>
            </div>
          )}
        </div>

        <button className="blog_submit" type="submit">
          {editingPost ? "Update Blog" : "Submit Blog"}
        </button>

        {message && <p>{message}</p>}
      </form>
    </div>
  );
};

export default CreateBlog;
